import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.iterator";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import cropperImg from "@/components/common/cropperImg.vue";
import ShowItemForm from "./showItemForm";
import SearchItemForm from "./searchItemForm";
import { sysFileUpload, sysFileDelete } from "@/api/managementCenter/otherApi";
import { sysDatasourceQuerySave, sysDatasourceQueryId, sysDatasourceQueryUpdate } from "@/api/management/search";
export default {
  name: "Add",
  components: {
    cropperImg: cropperImg,
    ShowItemForm: ShowItemForm,
    SearchItemForm: SearchItemForm
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      show: false,
      loading: false,
      formData: {
        name: "",
        icon: "",
        querySql: "",
        type: "",
        queryResultDefList: [],
        queryCondDefList: []
      },
      ruleValidate: {
        name: [{
          required: true,
          message: "名称不能为空",
          trigger: "blur"
        }],
        // icon: [
        //   {required: true, message: '请上传图标', trigger: 'blur'}
        // ],
        querySql: [{
          required: true,
          message: "SQL不能为空",
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: "请选择显示模板",
          trigger: "blur"
        }]
      },
      fileList: [],
      title: "新增"
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    handleClose: function handleClose() {
      this.resetForm();
      this.show = false;
    },
    resetForm: function resetForm() {
      this.formData = {
        id: "",
        name: "",
        icon: "",
        querySql: "",
        type: "",
        queryResultDefList: [],
        queryCondDefList: []
      };
      this.fileList = [];
      this.$refs.answerForm.resetFields();
    },
    dialogOpen: function dialogOpen(row) {
      var _this2 = this;

      this.show = true;

      if (row) {
        this.title = "编辑";
        this.loading = true;
        sysDatasourceQueryId(row.id).then(function (_ref) {
          var data = _ref.data;

          if (data.code == 0) {
            var resData = data.data;
            _this2.formData.name = resData.name;
            _this2.formData.id = resData.id;
            _this2.formData.querySql = resData.querySql;
            _this2.formData.type = Number(resData.type);
            _this2.formData.queryResultDefList = resData.queryResultDefList;
            _this2.formData.queryCondDefList = resData.queryCondDefList;

            if (resData.icon) {
              _this2.fileList = [{
                id: resData.icon,
                url: resData.iconUrl
              }];
            }

            _this2.$refs.showItemForm.forEach(function (item) {
              item.setDefualtData();
            });

            _this2.$refs.searchItemForm.forEach(function (item) {
              item.setDefualtData();
            });
          } else {
            _this2.$message.error(data.msg || "请求出错");
          }
        }).finally(function () {
          _this2.loading = false;
        });
      }

      if (this.formData.queryResultDefList.length == 0) {
        this.addQueryResultDefList();
      }

      if (this.formData.queryCondDefList.length == 0) {
        this.addQueryCondDefList();
      }
    },
    handleBeforeUpload: function handleBeforeUpload(file) {
      if (this.fileList.length > 0) {
        return this.$message.error("只能上传一张专题图片！");
      }

      var isLt1M = file.size / 1024 / 1024 < 1;

      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过 1MB!");
        return isLt1M;
      }

      this.$refs.cropperImg.uploadImg(file);
      return;
    },
    uploadHttp: function uploadHttp(file) {
      var _this3 = this;

      var fd = new FormData();
      fd.append("fromTarget", 2);
      fd.append("file", file); //上传到后台

      this.loading = true;
      sysFileUpload(fd).then(function (_ref2) {
        var data = _ref2.data;
        _this3.loading = false;

        if (data.code == 0) {
          _this3.$refs.cropperImg.closeDialog();

          _this3.$message.success("上传文件成功!");

          _this3.fileList.push(_objectSpread({}, data.data));
        } else {
          _this3.$message.warning(data.msg || "上传文件失败!");
        }
      }).catch(function (err) {
        _this3.loading = false;

        _this3.$message.error("上传文件异常!");
      });
    },
    handlePreview: function handlePreview() {
      window.open(this.fileList[0].url);
    },
    handleRemove: function handleRemove() {
      this.deleteFile(this.fileList[0].id);
      this.fileList = [];
    },
    deleteFile: function deleteFile(id) {
      var _this4 = this;

      sysFileDelete(id).then(function (_ref3) {
        var data = _ref3.data;

        if (data.code == 0) {
          _this4.$message.success("删除成功!");
        } else {
          _this4.$message.warning(data.msg || "删除失败！");
        }
      }).catch(function (err) {
        _this4.$message.error("删除异常!");
      });
    },
    addQueryResultDefList: function addQueryResultDefList() {
      this.formData.queryResultDefList.push({
        exchange: [],
        fieldName: "",
        fieldType: "",
        showName: "",
        key: new Date().getTime() // 唯一标识避免渲染错误

      });
    },
    addQueryCondDefList: function addQueryCondDefList() {
      this.formData.queryCondDefList.push({
        exchange: [],
        type: "",
        queryField: "",
        showName: "",
        key: new Date().getTime() + 1 // 唯一标识避免渲染错误

      });
    },
    removeItemForm: function removeItemForm(obj) {
      this.formData[obj.dataName].splice(obj.index, 1);
    },
    showItemFormChange: function showItemFormChange(obj) {
      this.formData.queryResultDefList[obj.index] = obj.data;
    },
    searchItemFormChange: function searchItemFormChange(obj) {
      this.formData.queryCondDefList[obj.index] = obj.data;
    },
    addSubmit: function addSubmit() {
      var _this5 = this;

      var _this = this;

      this.$refs.answerForm.validate(function (valid) {
        Promise.all([_this.validateChildrenForm("showItemForm", "queryResultDefList"), _this.validateChildrenForm("searchItemForm", "queryCondDefList")]).then(function (res) {
          if (valid && res) {
            // this.formData.queryResultDefList = res[0];
            // this.formData.queryCondDefList = res[1];
            _this5.loading = true;
            var rq = _this5.title === "新增" ? sysDatasourceQuerySave : sysDatasourceQueryUpdate;
            rq(_this5.formData).then(function (_ref4) {
              var data = _ref4.data;

              if (data.code == 0) {
                _this5.$message.success("操作成功");

                _this5.resetForm();

                _this5.$emit("refresh");

                _this5.show = false;
              } else {
                _this5.$message.error(data.msg || "请求出现异常, 保存失败");
              }
            }).finally(function () {
              _this5.loading = false;
            });
          }
        });
      });
    },
    validateChildrenForm: function validateChildrenForm(formName, listName) {
      var resultArr = [];

      var _this = this;

      function checkForm(index) {
        var result = new Promise(function (resolve, reject) {
          _this.$refs[formName][index].$refs.cFrom.validate(function (valid) {
            if (valid) {
              resolve(_this.$refs[formName][index].getValue());
            } else {
              reject();
            }
          });
        });
        resultArr.push(result);
      }

      this.formData[listName].forEach(function (item, index) {
        checkForm(index);
      });
      return new Promise(function (resolve) {
        Promise.all(resultArr).then(function (res) {
          resolve(res);
        });
      });
    }
  },
  watch: {
    fileList: function fileList(value) {
      if (value.length) {
        this.formData.icon = value[0].id;
      } else {
        this.formData.icon = "";
      }
    }
  },
  filters: {}
};